module.exports = __webpack_public_path__ + "static/media/trash.c6713ac8.png";